export default "__VITE_ASSET__1ukn64XP__"